<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img @click="closeModal()" src="@/assets/icons/close.png" alt="close-modal-img">
    </div>
    <div class="modal-title">
      {{modalData.usr_name}}
    </div>
    <table v-if="windowWidth >= 500">
      <thead>
        <tr>
          <td>{{$t('profile.buyers.product')}}</td>
          <td>{{$t('profile.buyers.date')}}</td>
          <td>{{$t('profile.buyers.status')}}</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(transaction, index) in transactions" :key="index">
          <td>
            {{transaction.pro_name}}
          </td>
          <td>
            {{$moment.utc(transaction.pro_expiry).local().format("YYYY-MM-DD HH:mm")}}
          </td>
          <td>
            {{getStatus(transaction.off_status, transaction.sold_out, transaction.expired)}}
          </td>
        </tr>
      </tbody>
    </table>
    <table class='mobile-table' v-if="windowWidth < 500">
      <tbody>
        <tr v-for="(transaction, index) in transactions" :key="index">
          <td>
            {{transaction.pro_name}}
          </td>
          <td class="light-grey">
            {{$moment.utc(transaction.pro_expiry).local().format("YYYY-MM-DD HH:mm").substring(0, 10)}}
          </td>
          <td class="status-color">
            {{getStatus(transaction.off_status, transaction.sold_out, transaction.expired)}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'mySellersSellerHistory',
  props: {
    modalData: {
      required: true
    }
  },
  data () {
    return {
      transactions: [],
      windowWidth: window.innerWidth
    }
  },
  mounted () {
    this.getRecord()
    window.addEventListener('resize', this.onResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize () {
      this.windowWidth = window.innerWidth
    },
    getRecord () {
      let params = {
        id: this.modalData.usr_id
      }
      api.getSellerHistory(params).then(res => {
        this.transactions = res.data.data
      }).catch(e => {
        console.log(e)
      })
    },
    closeModal () {
      eventBus.$emit('closeModal')
    },
    getStatus (status, soldOut, expired) {
      if (status === 1) {
        if (expired === 1 || soldOut === 1) {
          return this.$t('profile.buyers.statusSoldFinished')
        }
        return this.$t('profile.buyers.statusSold')
      } else if (status === 2) {
        return this.$t('profile.buyers.statusBuyerGaveUp')
      } else if (status === 3) {
        return this.$t('profile.buyers.statusRejected')
      } else if (status === 4) {
        return this.$t('profile.buyers.statusRejectedAdmin')
      } else if (status === 5) {
        return this.$t('profile.buyers.statusContract')
      } else {
        return this.$t('profile.buyers.statusUnknown')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/tableStyles.scss';
table {
  border: none;

  td {
    border-bottom: none !important;
  }
  tbody tr:nth-child(odd) {
    background: rgba(196, 196, 196, .15);
  }
}
.modal-wrapper {
  width: 650px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;

  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
}
.mobile-table {
  tbody tr {
    background: none!important;
    border-bottom: 1px solid #ddd;
    display: flex;
    flex-wrap: wrap;
  }
  tbody tr td {
    border-bottom: none;
    vertical-align: top;
    width: 50%;
    height: 100%;
    padding: 5px;
  }
  tr td:last-child {
    width: 100%;
  }
}
.bold-td-text {
  font-weight: 700;
  font-size: 17px;
}
.regular-td-text {
  font-weight: 500;
  font-size: 14px;
}
.light-grey {
  color: #9B9B9B;
  text-align: right;
  vertical-align: top;
  font-weight: 400;
  font-size: 13px;
}
.status-color {
  color: #8E3E4C;
  text-align: right;
  font-weight: 600;
  font-size: 13px;
}
</style>
